export const ClockIcon = ({
  color = '#5A5A5A',
  width = 16,
  height
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height ?? width}
      viewBox={`0 0 ${width} ${height ?? width}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C5.87824 16 3.84346 15.1571 2.34318 13.6568C0.842851 12.1566 0 10.1217 0 8C0 5.8783 0.842851 3.84346 2.34318 2.34318C3.8434 0.842851 5.8783 0 8 0C10.1217 0 12.1565 0.842851 13.6568 2.34318C15.1571 3.8434 16 5.8783 16 8C16 10.1217 15.1571 12.1565 13.6568 13.6568C12.1566 15.1571 10.1217 16 8 16ZM8 1.33353C6.23193 1.33353 4.53631 2.03587 3.28603 3.28609C2.03581 4.53631 1.33348 6.23207 1.33348 8.00006C1.33348 9.76804 2.03581 11.4637 3.28603 12.714C4.53625 13.9642 6.23201 14.6666 8 14.6666C9.76799 14.6666 11.4637 13.9642 12.714 12.714C13.9642 11.4638 14.6665 9.76804 14.6665 8.00006C14.6665 6.82987 14.3585 5.68022 13.7734 4.66665C13.1883 3.65326 12.3467 2.81164 11.3333 2.2265C10.3198 1.64145 9.17025 1.33353 8 1.33353ZM9.4867 10.4669L7.53337 8.50754C7.39565 8.37216 7.32277 8.18423 7.33338 7.99149V4.66694C7.33338 4.42877 7.46038 4.20868 7.66663 4.0896C7.87288 3.97051 8.12711 3.97051 8.33337 4.0896C8.53962 4.20868 8.66662 4.42877 8.66662 4.66694V7.68749L10.4666 9.48747C10.6416 9.66247 10.7098 9.91773 10.6457 10.1567C10.5816 10.3957 10.3947 10.5824 10.1557 10.6464C9.91662 10.7104 9.66159 10.642 9.4867 10.4669Z"
        fill={color}
      ></path>
    </svg>
  );
};
